/** Available "Iron Logic" converter modes */
export enum IronLogicConverterModeEnum {
  /** Normal (default) mode */
  NORMAL = 'NORMAL',
  /** Door locked */
  LOCKED = 'LOCKED',
  /** Door opened */
  PASS_FREE = 'PASS_FREE',
  /** Door opening pending */
  PASS_FREE_PENDING = 'PASS_FREE_PENDING',
}
